export default "__VITE_ASSET__DUUyr2Z5__"